import QuickView, { useQuickView, useSlides } from 'components/quickView';
import AntiBreakQuickViewContent from './AntiBreakQuickViewContent';
import { DefaultQuickViewHeader } from 'components/quickView/components/DefaultQuickViewComponents/Header';
import type { BasketDeliveryFixViewModel } from 'autogen/swagger/all';
import styled from 'styled-components';
import { breakpoint } from 'variables';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import TrackingContext from 'modules/tracking/GA4/helpers/TrackingContext';
import DefaltBackButton from 'components/quickView/components/DefaultQuickViewComponents/BackButton';

export type AntiBreakQuickViewProps = {
    model: BasketDeliveryFixViewModel;
};

const StyledQuickView = styled(QuickView)`
    ${breakpoint.up('768px')} {
        max-width: 500px !important;
        max-height: 80% !important;
    }
`;

function AntiBreakQuickView(props: AntiBreakQuickViewProps) {
    const { model } = props;
    const { slideProps, pop, slides } = useSlides({
        BackButtonRenderer: () => (
            <DefaltBackButton
                onClick={() => {
                    if (slides.length === 1) {
                        GA4Tracking({
                            eventName: 'go_to_anti_break_step_1',
                            context: 'basket',
                            category: 'ecommerce'
                        });
                    }

                    pop();
                }}
                rounded
            />
        )
    });
    const { toggle } = useQuickView('antiBreakQuickView');

    function handleOnClose() {
        toggle(false);
        GA4Tracking({
            eventName: 'close_modal',
            context: 'basket',
            category: 'ecommerce',
            eventParams: [
                {
                    param_name: 'modal_type',
                    param_value: 'anti_break'
                }
            ]
        });
    }

    return (
        <TrackingContext
            category="ecommerce"
            context="basket"
            eventParams={[{ param_name: 'is_anti_break', param_value: true }]}
        >
            <StyledQuickView
                {...slideProps}
                headerRenderer={DefaultQuickViewHeader}
                quickViewId="antiBreakQuickView"
                onClose={handleOnClose}
            >
                <AntiBreakQuickViewContent model={model} />
            </StyledQuickView>
        </TrackingContext>
    );
}

export default AntiBreakQuickView;
